export default __webpack_public_path__ + "assets/images/g-last-icon2-d407fe1d.svg";